import { render } from "./liveProducts.vue?vue&type=template&id=79ab8cb0"
import script from "./liveProducts.vue?vue&type=script&lang=js"
export * from "./liveProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__